"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Target, Eye, Heart } from "lucide-react";
export default function 会社概要() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const items = [{
    icon: Target,
    title: "ミッション",
    description: "日本企業のベトナム市場進出を成功に導き、持続可能なビジネス成長を実現する。",
    ref: ref1,
    isVisible: isVisible1,
    delay: "delay-0"
  }, {
    icon: Eye,
    title: "ビジョン",
    description: "日本とベトナムを結ぶ最も信頼されるビジネスパートナーとなる。",
    ref: ref2,
    isVisible: isVisible2,
    delay: "delay-100"
  }, {
    icon: Heart,
    title: "バリュー",
    description: "誠実さ、専門性、革新性を軸に、クライアントの成功を第一に考える。",
    ref: ref3,
    isVisible: isVisible3,
    delay: "delay-200"
  }];
  return <section className="relative bg-background py-24 overflow-hidden">
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: `repeating-linear-gradient(
            45deg,
            hsl(210, 35%, 15%),
            hsl(210, 35%, 15%) 10px,
            transparent 10px,
            transparent 20px
          )`
    }} />
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {items.map((item, i) => {
          const IconComponent = item.icon;
          return <div key={i} data-index={i} ref={item.ref} className={`transition-all duration-700 ease-out ${item.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"} ${item.delay}`}>
                <Card className="h-full border border-border shadow-soft hover:shadow-strong transition-all duration-300 group bg-background hover:bg-primary-light/30">
                  <CardHeader className="text-center pb-4">
                    <div className="flex justify-center mb-4">
                      <div className="relative">
                        <div className="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 transition-all duration-300 group-hover:scale-105">
                          <IconComponent className="w-10 h-10 text-primary group-hover:scale-110 transition-transform duration-300" strokeWidth={1.5} />
                        </div>
                        <div className="absolute inset-0 rounded-full bg-accent/0 group-hover:bg-accent/10 blur-xl transition-all duration-300 -z-10" />
                      </div>
                    </div>
                    <CardTitle className="text-2xl text-primary font-display">
                      {item.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="text-center">
                    <p className="text-foreground/80 leading-relaxed">
                      {item.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}